<script setup lang="ts">
  const error = useError();
  const loading = ref(true);
  setTimeout(() => {
    loading.value = false;
  }, 3000);

  const handleError = () => {
    location.reload();
  };
</script>

<template>
  <div class="error-container">
    <CircleLoader v-if="loading" />
    <div v-else class="error-container">
      <SolEmptyState
        id="partner-not-found"
        variant="error404"
        class="empty-state"
        title="Não foi possível carregar a página"
        :subtitle="
          error?.message ||
          'Ocorreu um erro ao recuperar algumas informações. Por favor, tente novamente.'
        " />
      <SolButton id="button-not-found" class="mt-6" @click="handleError">
        Tentar novamente
      </SolButton>
    </div>
  </div>
</template>

<style lang="css">
  .error-container {
    @apply flex flex-col justify-center items-center;
    height: 100vh;
  }
</style>
